import { ApexOptions } from 'apexcharts';

export const donutOptions = {
  grid: {
    padding: {
      left: 0,
      right: 0,
    },
    borderColor: 'transparent',
  },
  stroke: {
    colors: ['transparent'],
  },
  dataLabels: {
    enabled: true,
  },
  tooltip: {
    enabled: false,
  },
  legend: {
    show: false,
    floating: true,
    fontSize: '12px',
    position: 'left',
    offsetX: 0,
    offsetY: -15,
    labels: {
      useSeriesColors: true,
    },
    formatter: function (seriesName, opts) {
      return seriesName + ':  ' + opts.w.globals.series[opts.seriesIndex];
    },
    itemMargin: {
      vertical: 3,
    },
  },
  plotOptions: {
    radialBar: {
      offsetY: 0,
      startAngle: 40,
      endAngle: 225,
      track: {
        background: '#333333',
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: false,
        },
      },
    },
  },
  colors: [],
  labels: [],
};

export const lineOptions = {
  grid: {
    show: false,
    padding: {
      left: 0,
      right: 0,
    },
  },
  yaxis: {
    labels: {
      show: true,
      offsetX: 370,
      align: 'left',
      style: {
        colors: 'var(--color-five)',
      },
    },
    axisBorder: {
      show: true,
      offsetX: -50,
      color: 'var(--color-five)',
    },
    axisTicks: {
      show: false,
    },
    tickAmount: 6,
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  chart: {
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  stroke: {
    show: true,
    width: 2,
    curve: 'straight',
  },
  dataLabels: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  legend: {
    show: false,
    position: 'bottom',
    onItemClick: {
      toggleDataSeries: false,
    },
  },
  colors: [],
};
